module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("A Canadian Girl in South Africa")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle-pre"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("LORD MINTO")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("was looking for a few good women. Forty, to be precise. In the early months of 1902 Canada’s governor general had before him an urgent request from Britain’s colonial secretary, Joseph Chamberlain. To consolidate wartime gains and secure British control in South Africa, Chamberlain was keen to recruit female teachers"), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote1",
      "id": "rfootnote1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[1]")]), _vm._v(" from Canada, Australia, and New Zealand to assist Britain in educating Boer"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote2",
      "id": "rfootnote2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[2]")])]), _vm._v(" children living in Transvaal and Orange River Colony concentration camps."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote3",
      "id": "rfootnote3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[3]")])]), _vm._v(" He asked for forty of Canada’s top teachers and provided Minto with details of the scheme. In doing so, he strongly encouraged Canadian officials to undertake personal interviews with potential candidates, declared that Roman Catholics should not be considered for these positions, and demanded that “no teacher is selected who is opposed to British rule in South Africa.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote4",
      "id": "rfootnote4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[4]")])]), _vm._v(" Federal officials went straight to work recruiting Canada’s best and brightest young female teachers. Working closely with provincial authorities, they issued a call for volunteers and were overwhelmed by the response, for in just a few months over five hundred women put forward their names for consideration."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote5",
      "id": "rfootnote5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[5]")])])]), _vm._v(" "), _c('p', [_vm._v("Humanitarian and imperial rationales intertwined as the scheme was developed. Recalling her briefings en route to the camps, Isabel Perry, a teacher from Montreal, noted that “our mission was a very important one, equally as important as that of the soldiers, for it was to implant feelings of loyalty to the British flag in the hearts of the Dutch children and to endeavour to reconcile Dutch women to British rule.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote6",
      "id": "rfootnote6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[6]")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("To this end, the recruitment campaign focused intently on finding the right women for the job. As he sifted through applications from Manitobans, for example, W.A. McIntyre, principal of the Normal School in Winnipeg, endorsed candidates who fit an ideal of Canadian and imperial womanhood. Susie Younghusband was a model prospect. She had ten years of teaching experience, “most of it with younger pupils,” was “kind, patient,” and “tender,” and was “loved by pupils and respected by mothers.” Just as important, McIntyre noted, she “possesses the missionary spirit.” And since she was “accustomed to working under adverse conditions,” she “would be a quiet but effective force for good in a new community” and “would do nothing foolish.” Margaret MacDonald was another of McIntyre’s favourites: She had a “very fine character,” was “gentle” and “ladylike,” and possessed “a proper missionary spirit.” McIntyre was also keen to support Edith Murray, “a bright and capable teacher” who boasted “dash, vigor, and strong individuality.”"), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote7",
      "id": "rfootnote7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[7]")]), _vm._v(" Across Canada the search was on for female teachers who were nurturing but confident, experienced but energized, and, above all, dedicated to the task at hand: remaking South Africa in Britain’s image.")]), _vm._v(" "), _c('p', [_vm._v("Enter Maud Graham, an intelligent and resourceful young woman, who, in 1902, was serving as a governess in Quebec. Graham lacked the extensive teaching experience of some of the other candidates but boasted first-rate teacher-training qualifications. Given the prohibition on Catholics, her Methodist background also stood her in good stead. An active athlete in university, her physical fitness was another feather in her cap, for the authorities were keen to find women capable of working hard and living under rough conditions. In addition, her musical training meant that she would appeal to officials keen to adhere to the British government’s observation that the “ability to teach singing is an essential qualification” for applicants."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote8",
      "id": "rfootnote8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[8]")])]), _vm._v(" Finally, and equally importantly, she was keen to do her part for the empire.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/Page_14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maud Graham’s route to South Africa, 1902.")])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("But Maud Graham was also just genuinely excited by the prospect of travelling overseas. At the age of twenty-six she possessed maturity, self-confidence, and a keen interest in the world around her. As those unlucky enough to raise her ire could quickly learn, she also possessed a sharp tongue and did not suffer fools gladly. Chosen as one of seven teachers from Quebec, Graham set off for South Africa in April 1902—and recorded her experience for posterity. The result was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Canadian Girl in South Africa")]), _vm._v(", originally published in Toronto by William Briggs in 1905, a memoir of her two-year experience as a teacher in South Africa, first in a concentration camp for Boer refugees of the South African War (1899–1902) and afterwards in schools for Boer children in two small towns. In addition to documenting her own activities as a teacher in South Africa, Graham offered extensive observations on race relations, postwar reconstruction, and farming and economic development. She saved her most biting critiques for what she perceived to be woeful, and potentially tragic, failures in educational policy perpetrated by “men of mediocre talent…and sometimes more than mediocre stupidity” (Chapter XIII). Just how Maud Graham held her tongue during the formal interview requirement of the selection process is unclear. But we are glad that she did.")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("In providing a first-person account of the final days of that epic war, daily life in a concentration camp, settler–African relations, and more, Graham’s book is invaluable for scholars concerned with the South African War, the creation of the South African state, imperial racism, gender and colonialism, colonial education, travel writing, and the formation of and tension between British colonial and imperial identities. Moreover, the book, and the scheme that it documents, offers a window onto a key moment in the history of the “British World.” The South African War, and Britain’s call for military, and then pedagogical, support, occurred amidst an awkward and contested refashioning of its relationship with its white settler societies. As John Eddy and Deryck Schreuder explain, “keeping the British Empire of settlement together became an increasingly ")]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("urgent matter from the Anglo-Boer War…onwards,” and Joseph Chamberlain was perhaps the central figure in a campaign to “call on the colonies of white settlement for greater co-operation in carrying the burdens of empire.”"), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote9",
      "id": "rfootnote9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[9]")]), _vm._v(" This would prove no easy task; as essayist and traveller Richard Jebb noted in 1905, the populations of Canada, Australia, and New Zealand were each developing a variation of what he termed “colonial nationalism”—an outlook that increasingly prioritized local autonomy and self-interest while retaining and respecting their political and cultural connections to Britain."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote10",
      "id": "rfootnote10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[10]")])]), _vm._v(" As Jebb detailed at length in his study, the South African War profoundly shaped their shifting conceptions of the proper relationship with the mother country and divided public opinion in all three societies."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote11",
      "id": "rfootnote11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[11]")])]), _vm._v(" The conflict that in Chamberlain’s mind necessitated the enlistment of Canadian teachers for the imperial cause thus brought into sharp relief the divergent interests of Britain and its white settler societies.")]), _vm._v(" "), _c('p', [_vm._v("Yet Graham’s story, which featured British, Canadian, Australian, and New Zealand women travelling abroad to assist in the reconstruction of South African society, is also an important reminder of the transnational nature of the British World at the beginning of the twentieth century—and of the cultural bonds that continued to unite these settlements."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote12",
      "id": "rfootnote12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[12]")])]), _vm._v(" Recent studies on a wide range of topics including music, education, and the law have underscored the persistent influence of British culture beyond the boundaries of the United Kingdom."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote13",
      "id": "rfootnote13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[13]")])]), _vm._v(" English Canadians were not alone in struggling to articulate a patriotism that balanced local interests and a cultural allegiance to Great Britain. Nor were their actions on this front confined to Canada’s borders. Their lives and identities were shaped, directly in the case of Maud Graham, by experiences and developments on the other side of the world.")]), _vm._v(" "), _c('p', [_vm._v("Like Canadian adventurer William Stairs, who travelled to Equatoria in 1887 to assist Henry Stanley in rescuing Emin Pasha from his Muslim captors and to Katanga in 1891 to flex his muscles on behalf of Belgium’s King Leopold, Maud Graham was a colonial "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_vm._v("contributor to imperial endeavours. But while Stairs’s pursuits were facilitated by well-recognized mechanisms of imperial power—training at Kingston, Ontario’s Royal Military College, a stint with the Royal Engineers in England, and then key roles on the two state-sponsored formal expeditions replete with graphic violence—Graham’s adventure, befitting a woman at the turn of the century, unfolded amidst the more prosaic setting of a make-shift classroom and group sing-a-longs."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote14",
      "id": "rfootnote14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[14]")]), _vm._v(" It was, nonetheless, a staunchly imperial undertaking—one explicitly designed to maintain and enhance Britain’s hegemony in Southern Africa amidst growing fears of a looming reckoning for the British Empire.")]), _vm._v(" "), _c('p', [_vm._v("Moreover, it shared with many imperial, neocolonial, and contemporary development schemes an exaggerated confidence in its ability to “save” imperiled children from a despondent present and bleak future. A growing literature critically assessing the unintended consequences of Global South development schemes insists on the need to recognize the cultural assumptions that inform policy development and the actions of on-the-ground workers and volunteers."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote15",
      "id": "rfootnote15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[15]")])]), _vm._v(" It underscores the difficulties involved in actually delivering tangible goods and services to the targeted population."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote16",
      "id": "rfootnote16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[16]")])]), _vm._v(" And, for sub-Saharan Africa, in particular, it documents a repeated tendency to view the continent as “sufficiently exotic, and far enough away” that it can be approached “with a kind of untroubled certainty.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote17",
      "id": "rfootnote17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[17]")])]), _vm._v(" The scheme to anglicize and “uplift” Boer children in 1902 lacked such reflective observations. As with so many British imperial endeavours, it was shaped by a combination of altruistic ideals (assisting displaced civilians to become more civilized) and Machiavellian goals (reasserting British control in an important economic and military location). In Graham’s words, the benefits that she and others brought to Boer children meant that “such people were never so well off in their lives as when in camp” (Chapter V). As Ann Stoler notes in her study of the Dutch Indies, children’s welfare was an important symbolic marker of colonial success (or failure). “Children were seen to be particularly "), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("susceptible to degraded environments,” she explains, “and it is no accident that colonial policy makers looked to upbringing and education, to schools and homes…and thus to the quotidian social ecology of children’s lives.”"), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote18",
      "id": "rfootnote18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[18]")])]), _vm._v(" "), _c('p', [_vm._v("That the plan to send teachers to South Africa appealed so strongly to women across Canada and elsewhere is also significant. As Barbara Heron observes, the majority of workers in today’s development industry are middle-class white women."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote19",
      "id": "rfootnote19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[19]")])]), _vm._v(" The roots of this phenomenon, she argues, were planted in the late nineteenth century. Constraints on middle-class women’s place in the public sphere combined with an idealization of them as nurturing and selfless “white mother-teacher[s]” to encourage thousands of women to embrace the possibilities of social reform and missionary work."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote20",
      "id": "rfootnote20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[20]")])]), _vm._v(" While the nature of overseas development initiatives has changed significantly over time, Heron notes some important “colonial continuities” informing contemporary female development workers’ motivations, including a sense of obligation and entitlement."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote21",
      "id": "rfootnote21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[21]")])]), _vm._v(" Maud Graham and the other thirty-nine white, middle-class female Canadian teachers who embraced the opportunity to travel to South Africa in 1902 are an important part of this story.")]), _vm._v(" "), _c('p', [_vm._v("In the pages that follow, we begin by providing a brief overview of the war itself, including both its causes and impact. In doing so, we highlight the value of Graham’s story for understanding life in the concentration camps, their contested political legacy, and the ramifications of British educational policy in South Africa during the postwar reconstruction period. We then provide a detailed biography of Maud Graham that explores the cultural influences that shaped her assessment of her overseas adventure. Finally, we introduce readers to the book itself by focusing on Graham’s national (and imperial) identity, her observations as an overseas traveller, her experience as a teacher in South Africa, the manner in which her observations were refracted through common racial categories of the time, and the liminal position she occupied as a New Woman at the turn of the century.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("THE SOUTH AFRICAN WAR")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("The South African War was fought between the British Empire and the two Boer republics, the South African Republic (also known as the Transvaal) (SAR; est. 1852) and the Orange Free State (OFS; est. 1854), though its effects were also profound for indigenous African inhabitants in the region. The conflict was the culmination of decades of intensifying hostility between the two white groups. The British formally secured the Cape Colony, originally settled by the Dutch Vereenigde Oost-Indische Compagnie (United East India Company), in 1814, and from the start relations were tense with the established Boer settlers. The British infuriated the Boer population by abolishing slavery throughout the empire (in 1834) and fostering British settlement and culture in the colony. Consequently, starting in the 1830s, thousands of Boers left the Cape and travelled north by ox-wagon in search of land, freedom from governmental authority, and the ability to continue practicing white dominance without British interference. Ultimately, after many clashes with African kingdoms and a relentless process of encroaching on their lands, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Voortrekkers")]), _vm._v(" (pioneers) established the two republics.")])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('p', [_vm._v("At first the British had no interest in conquering the Boer states but the discovery of valuable mineral deposits on their territories (diamonds in OFS in 1867 and gold in SAR in 1886) changed everything. For economic and strategic reasons, the British wanted control of the entire region, and their efforts to obtain it inevitably provoked hostilities between the two settler populations. In 1877 Britain annexed the SAR and renamed it the British Colony of the Transvaal; three years later, Boers in the colony (aided by the OFS) revolted against British rule in what has become known as the First Anglo-Boer War (also called the First Transvaal War of Independence) that lasted from November 1880 to March 1881.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("The discovery of gold in the SAR five years later rekindled British land lust and spurred plans for another annexation. The two Boer republics, feeling increasingly provoked and under threat of invasion, joined forces and attacked the British first in hopes of gaining the upper hand in a war they considered unavoidable."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote22",
      "id": "rfootnote22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[22]")]), _vm._v(" They invaded the Cape Colony in October 1899, thereby starting the South African War (known at the time as the Second Anglo-Boer War). The Boer attack had the effect of mobilizing Britain’s military and unifying colonial support for the British, and nearly five hundred thousand British troops were ultimately sent to the region. In Canada, despite vociferous French Canadian hostility towards the British Empire, Prime Minister Wilfrid Laurier’s cabinet approved enlisting, equipping, and transporting a Canadian contingent of volunteers a few days after the outbreak of hostilities. Over seven thousand Canadian soldiers served in the war."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote23",
      "id": "rfootnote23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[23]")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/Page_20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Boer republics and British colonies during the South African War.")])])]), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_vm._v("British imperial strategists assumed the war would be easy to win and quickly over. After all, they wondered, how long could it take for the world’s most powerful military to defeat the republics’ rag-tag commandos comprised mainly of farmers? Indeed, in the beginning, events unfolded as expected: by September 1900, Britain had annexed the two republics, immediately renamed the Transvaal and Orange River Colony, and victory seemed at hand. But the Boers proved surprisingly tenacious, daring, and wily; rather than engaging British troops directly in a traditional style of warfare, they employed guerrilla tactics, learned during decades of war with indigenous Africans, that were extremely difficult to counteract. In response, in March 1901, Lord Horatio Kitchener (1850–1916), charged with devising a strategy for dealing with the commandos, set out to destroy all sources of food, shelter, and information that were sustaining the Boer soldiers with a vicious scorched earth campaign: British soldiers destroyed Boer farms, seized or killed their livestock and poisoned water wells."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote24",
      "id": "rfootnote24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[24]")]), _vm._v(" Boers made homeless by the campaign either fled for refuge or were forcibly relocated to civilian camps.")]), _vm._v(" "), _c('p', [_vm._v("Originally, the British had established camps to bestow political recognition to “protected burghers,” republican citizens who had surrendered voluntarily, and to ensure their protection from "), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_vm._v("retaliation by Boer forces (who nicknamed them the “hands-uppers”). Starting in September 1900, protected burghers and their families moved to “protection camps” where soon afterwards they were joined by victims of the scorched earth policy. Ultimately, the British removed over one hundred thousand Boers, mainly women and children, from their homes and “concentrated” them into camps established along railway lines on British-controlled territory. By the end of the war, there were about fifty camps for white civilians and sixty-four for the tens of thousands of black civilians who were also displaced during the campaign."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote25",
      "id": "rfootnote25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[25]")])]), _vm._v(" "), _c('p', [_vm._v("However, the British were ill prepared to manage the camps. Some camp authorities proved thoroughly incompetent. But others were simply overwhelmed because they were not given advance notice about military police incursions onto Boer land and thus could not properly prepare for the arrival of new refugees. Instead, victims of forced removals arrived at camps without prior warning, often putting administrators who were already facing a shortage of resources into an impossible position. Food, clothing, fuel, and medical care were consistently in short supply, the tents that provided shelter quickly became overcrowded, and the combination caused waves of deadly epidemics—measles, enteritis, and typhoid—as well as widespread outbreaks of diarrhea and pneumonia."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote26",
      "id": "rfootnote26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[26]")])])]), _vm._v(" "), _c('p', [_vm._v("British mismanagement, rather than deliberate cruelty, had lethal consequences: by the end of the war, approximately 28,000 Boers had died (about 10 per cent of the total Boer population), of which a shocking 22,000 were children. In the separate camps for Africans, whose accommodation and food supply were worse than in the Boer camps, at least 15,000 people perished."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote27",
      "id": "rfootnote27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[27]")])]), _vm._v(" In contrast, of the half million soldiers from across the empire who fought for the British, 21,000 died (the majority from disease)."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote28",
      "id": "rfootnote28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[28]")])]), _vm._v(" Ultimately, the war deeply unsettled the British public, not least because of the reportage of British humanitarian Emily Hobhouse (1860–1926), whose scathing accounts of what she saw in the camps caused a sensation."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote29",
      "id": "rfootnote29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[29]")])]), _vm._v(" In fact, the South African War played an important "), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_vm._v("role in the Conservative government’s comprehensive defeat in 1906."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote30",
      "id": "rfootnote30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[30]")]), _vm._v(" In Canada a vocal minority also expressed its opposition to the war."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote31",
      "id": "rfootnote31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[31]")])]), _vm._v(" Perhaps as a means of steeling Canada’s teachers against anti-British criticism, the federal government placed an order for forty-five copies of Arthur Conan Doyle’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The War in South Africa")]), _vm._v(", which included a spirited defence of the camps, a week before their scheduled departure."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote32",
      "id": "rfootnote32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[32]")])])]), _vm._v(" "), _c('p', [_vm._v("When the war finally ended, the British immediately sought political reconciliation with the Boers, and a major step taken towards its attainment was the policy of reconstruction for the ravaged ex-Boer republics where towns and farms had been devastated if not destroyed. Sir Alfred Milner (1854–1925), British high commissioner for Southern Africa from 1897 to 1905, obtained the necessary funds by levying a tax on the annual net produce of the Transvaal gold mines. The reason for pursuing a rapprochement was purely pragmatic and had nothing to do with a sense of guilt about the devastating effects of the war. The British were fearful of a possible “Native rebellion” across the region because Africans, who had mostly taken the British side during the war, expected to finally obtain the political and economic rights denied them under Boer rule."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote33",
      "id": "rfootnote33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[33]")])]), _vm._v(" However, the British never had any intention of ending racial discrimination, in part because of the overriding need to control the supply and flow of African labour for the lucrative mines, and also because doing so would outrage the Boers and make political reconciliation impossible. Instead, the solution Britain decided upon was to unite the four colonies into a cohesive colonial state loyal to Britain and able to effectively police Africans’ movements. Ultimately, in 1910, the Cape, Natal, Transvaal, and Orange River colonies combined to form the dominion of South Africa."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote34",
      "id": "rfootnote34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[34]")])])]), _vm._v(" "), _c('p', [_vm._v("In the four decades following their defeat, embittered Boers intent on constructing a new Afrikaner nationalist identity and winning control of the state produced what has since become the dominant narrative of the war, one of British brutality and Boer "), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_vm._v("suffering. During the 1930s, for example, the story that British camp managers had mixed ground glass in the sugar supply started to circulate and gain credibility; though false, some descendants of the Boers believe it to this day."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote35",
      "id": "rfootnote35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[35]")]), _vm._v(" By the Second World War, the history of the camps had been thoroughly politicized and the representation of victimized Boer women and children firmly harnessed to Afrikaner nationalism. However, the centenary of the South African War spurred historians with new research interests to take a fresh look at events and reconsider previous canonical conclusions."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote36",
      "id": "rfootnote36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[36]")])]), _vm._v(" As a result, recent scholarship employing new theoretical and political approaches has thrown into doubt crucial aspects of the Afrikaner nationalist version of the war. Historians implementing gender analysis,"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote37",
      "id": "rfootnote37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[37]")])]), _vm._v(" utilizing the Dutch and Afrikaans primary sources produced by the “losers,”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote38",
      "id": "rfootnote38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[38]")])]), _vm._v(" situating the war in the larger context of British imperialism,"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote39",
      "id": "rfootnote39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[39]")])]), _vm._v(" and placing Africans at the centre of analysis have displaced the almost exclusive focus on Boer victimization that lay at the heart of the previous, dominant narrative of the war.")]), _vm._v(" "), _c('p', [_vm._v("As sociologist Liz Stanley has reminded us, every official commemoration of a tragic event is accompanied by acts of forgetting."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote40",
      "id": "rfootnote40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[40]")])]), _vm._v(" In the case of the British concentration camps, the presence of Africans in the supposedly white camps has been almost entirely forgotten. Africans not only participated in the war as soldiers, they also acted as servants to wealthy Boer camp inhabitants, aides to camp staff, and forced labour that largely sustained all of the camps."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote41",
      "id": "rfootnote41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[41]")])]), _vm._v(" Their involvement has finally started to come into sharper focus not least because of the changing political context in which the war was being re-examined—namely, the demise of apartheid that had distorted and marginalized black South African experience and contributions to history.")]), _vm._v(" "), _c('p', [_vm._v("Scholars such as Stanley and Helen Dampier have also called for writing “everyday” experiences back into the history of the camps. In contrast to the dominant image of concentration camps that has "), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }, [_vm._v("gripped the public imagination in the aftermath of Nazism—one of slave labour and genocide—the camps in which Boers were interned were intended first and foremost to undermine Boer commandos, not to exterminate the civilian population, a crucial fact neglected in favour of “a nationalist version of events that represented the camps as places where the British carried out brutal mistreatment and even murder of Boer women and children.”"), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote42",
      "id": "rfootnote42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[42]")]), _vm._v(" Highlighting “the everyday” reveals many aspects of camp life that have been overlooked, including daily soup kitchens for white children and the elderly; regular church services; sports days; catechism classes for children; and the establishment of hospitals, shops where additional food could be purchased by inhabitants, and schools. Though the nationalist narrative of the war has been saturated with endlessly reproduced “iconic” images of rail-thin, dying, Boer children, Stanley describes how, in the course of conducting research, the vast majority of the thousands of photographs she examined concern prosaic elements of everyday life."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote43",
      "id": "rfootnote43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[43]")])])]), _vm._v(" "), _c('p', [_vm._v("Such observations are not intended to minimize the trauma and the tragedy of camps, places that were without question overcrowded, unpleasant, and frightening for most inhabitants and deadly to many. Instead, they are intended to help create discursive space for other, previously neglected, dimensions of camp experience such as that of the children “who were not ill or who survived and became well, helped their mothers, played with each other, went to school, enjoyed sports days and celebrations and amused themselves.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote44",
      "id": "rfootnote44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[44]")])]), _vm._v(" Indeed, many children appear to have enjoyed going to school: one woman recalled after the war that she cried when it was time to go home at the end of the day."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote45",
      "id": "rfootnote45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[45]")])]), _vm._v(" A Canadian teacher who travelled with Graham to South Africa in 1902, Florence Randal, recalls how the children enjoyed learning so much that they “actually disliked holidays in the camp schools.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote46",
      "id": "rfootnote46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[46]")])]), _vm._v(" As historian Sarah Duff writes, “by emphasising white children’s victimhood, we lose sight of the broader picture of childhood in the camps during the South African War.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote47",
      "id": "rfootnote47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[47]")])]), _vm._v(" By describing activities she witnessed as a "), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }, [_vm._v("school teacher, such as food consumption and children playing games, Graham’s memoir helps deepen our understanding of daily life in the notorious British camps.")])]), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }, [_vm._v("And yet we must not lose sight of the fact that schooling for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kampkinders")]), _vm._v(" (camp children) formed part of an explicit political project. Even as the war was still raging, Milner decided that the long-term success of the British in the region required fostering loyalty to the empire, and this in turn necessitated anglicizing the soon-to-be defeated Boers."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote48",
      "id": "rfootnote48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[48]")]), _vm._v(" Key to achieving this goal was teaching Boer children English, both as a means to curb anti-British sentiment and assimilate the Boers into British-dominated colonial life. As historians have shown in relation to colonized Africans, education was fundamental to colonial rule."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote49",
      "id": "rfootnote49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[49]")])]), _vm._v(" Colonial education consisted of a power-knowledge discourse aimed at enabling colonial subjects to imagine themselves as belonging to a particular cultural polity."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote50",
      "id": "rfootnote50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[50]")])]), _vm._v(" The British had high hopes that education would have the same effect on the conquered Boers.")]), _vm._v(" "), _c('p', [_vm._v("Beginning in 1901, Milner converted four Boer high schools in Pretoria into English schools, quickly nicknamed “Milner Schools.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote51",
      "id": "rfootnote51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[51]")])]), _vm._v(" He also oversaw the establishment of schools for Boer children in the concentration camps. (Education for African children was never considered.) His secretary of education for the two new British colonies, Edmund Beale Sargant (1855–1938), had an idea to win over “the young generation of Dutch Africanders to English ways of thought and speech and to English ideas of truthfulness and loyalty.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote52",
      "id": "rfootnote52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[52]")])]), _vm._v(" According to historian Eliza Riedi, Sargant had travelled to numerous colonies to study the role educational systems played in forging imperial unity, and the concentration camps offered an opportunity to put his theories into practice. Riedi writes, “Soon after arriving at Cape Town he visited a Boer prisoner-of-war camp where the prisoners had set up a school. Inspired, in late January 1901 he established a school at the nearest concentration camp, Norval’s Pont, and acted as headmaster for a fortnight. The experiment proving successful, Sargant decided to extend it over the whole camp system.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote53",
      "id": "rfootnote53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[53]")])]), _vm._v(" Milner, who had a low opinion of Boers and their culture, approved, believing that education would end their “retrogression” and make them “outward-looking” and open to “progress” and “modern civilization.” “Next to the composition of the population,” he said, “the thing that matters most is its education. Everything that makes South African children look outside South Africa and realize the world makes for peace.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote54",
      "id": "rfootnote54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[54]")])]), _vm._v(" Because teaching the English language was paramount to this objective, the main aim of the schools was to make children proficient in English and therefore, with the exception of religious education, Sargant wanted a total immersion program. Classes were conducted in English, regardless of children’s level of fluency in the language, and teaching the language dominated the curriculum, although some math, history, and geography were also taught, with the latter two subjects also imparting a British imperial worldview."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote55",
      "id": "rfootnote55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[55]")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/Page_27.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Graham’s text does not include images of the school at Norval’s Pont Camp, where she first worked. This photograph shows")]), _vm._v(" kampkinders "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("at the nearby Bloemfontein Camp School in 1901. "), _c('span', {
    staticClass: "fig"
  }, [_vm._v("[The Photographical Collection of the Anglo-Boer War Museum, Bloemfontein, South Africa, scan 00811]")])])])]), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/Page_29.jpg"
    }
  })])]), _c('p', {
    staticClass: "figcaption"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bloemfontein Camp School, 1901. "), _c('span', {
    staticClass: "fig"
  }, [_vm._v("[The Photographical Collection of the Anglo-Boer War Museum, Bloemfontein, South Africa, scan 00802]")])])])]), _c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxx"
    }
  }, [_vm._v("Initially, local teachers with the necessary proficiency in English were employed but the rapid expansion of the student population rendered this approach unsustainable: by May 1902, the last month of the war, there were more than 17,000 students in the Transvaal camps and over 12,000 in the Orange River Colony camps."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote56",
      "id": "rfootnote56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[56]")]), _vm._v(" Sargant told Milner in mid-June 1901 that “the opportunity during the next year of getting [the Boer children] to speak English is golden” and urged him to bring out patriotic young female teachers from England and the colonies; he “particularly admired the Canadian education system.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote57",
      "id": "rfootnote57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[57]")])]), _vm._v(" Milner agreed, for he was determined to bring Boer children “under influences which will promote future harmony of races.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote58",
      "id": "rfootnote58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[58]")])]), _vm._v(" (Milner was referring to harmony between the British and Boer “races” only."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote59",
      "id": "rfootnote59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[59]")])]), _vm._v(") In late 1901, the British Colonial Office began recruiting teachers from Britain and its colonies, among them Maud Graham, who arrived at war’s end to teach in the camp schools."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote60",
      "id": "rfootnote60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[60]")])]), _vm._v(" Graham was one of three hundred teachers from Britain, Canada, Australia, and New Zealand sent to the region that would soon become South Africa. As Riedi argues, this scheme presumed that young, white, professional, patriotic women were bringing “British "), _c('a', {
    attrs: {
      "id": "page_xxxi"
    }
  }, [_vm._v("civilization” to newly defeated enemies of the empire."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote61",
      "id": "rfootnote61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[61]")]), _vm._v(" Though the Colonial Office worried about the cost of recruiting teachers from the Dominions, Joseph Chamberlain (1857–1913), the secretary of state for the colonies, insisted it be done, saying, “it would please the Colonies.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote62",
      "id": "rfootnote62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[62]")])])]), _vm._v(" "), _c('p', [_vm._v("Teachers were required to commit to their posts for a year for an annual salary of £100. The authorities also offered the prospect of permanent employment to those wishing to stay on after the expiration of their one-year contract."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote63",
      "id": "rfootnote63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[63]")])]), _vm._v(" Applications flooded in, with over 3,000 from Britain alone and over 800 from Canada, New Zealand, and Australia. Applicants were white women, predominantly of lower-middle-class and middle-class backgrounds."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote64",
      "id": "rfootnote64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[64]")])]), _vm._v(" Joseph Chamberlain’s forceful suggestion that Catholic applicants not be considered for these positions was widely circulated amongst Canadian officials, thereby ensuring that the teachers from Canada were overwhelmingly Protestant."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote65",
      "id": "rfootnote65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[65]")])]), _vm._v(" Ultimately, 40 of the 300 teachers were recruited from Canada and sent to the Transvaal and Orange River Colony. After the Boers surrendered in May 1902, the refugees returned home and the camps were closed by September, after which the teachers were sent out in pairs to schools on Boer farms and in villages and small towns. Still perceived as important to the anglicization project, after completing their one-year contracts, the teachers were offered an increase in pay, free medical assistance, and free passage home as incentives to continue working, and many did, including Graham."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote66",
      "id": "rfootnote66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[66]")])])]), _vm._v(" "), _c('p', [_vm._v("In addition to anglicizing Boer children, the camp schools assisted the British government in defending its involvement in the South African War against critics such as Lloyd George (1863–1945), leader of the opposition Liberal Party. Anti-war sentiment had spread as a result of news coverage of the scorched earth policy and the lethal incarceration of Boer women and children, so the schools proved useful as propaganda. Defenders of the war emphasized the “humanitarian” nature of the camps, which were portrayed as safe refuges from war, starvation, and (by tapping into racist notions "), _c('a', {
    attrs: {
      "id": "page_xxxii"
    }
  }, [_vm._v("of African sexuality) the rape of white women by black men."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote67",
      "id": "rfootnote67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[67]")]), _vm._v(" As MP Alfred Lyttelton (1857–1913), the government’s chairman of the committee planning postwar reconstruction, explained in Parliament in response to criticism by Lloyd George, the camp schools")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("will go far…in the future to cement the relations between the Dutch and English populations…and certainly, primary education has never been initiated under more romantic circumstances….Children were brought in from the farms and placed under the care of the people of the camps…and there they have been taught by the very best teachers which this country could supply, especially women teachers…the most excellent teachers, out of the thousands who volunteered, have been sent to those camps to teach the children."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote68",
      "id": "rfootnote68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[68]")])])]), _vm._v(" "), _c('p', [_vm._v("Chamberlain also cited the schools when responding in Parliament to criticism of the camps. After vigorously defending the need for, and management of, the camps, in March 1902 he lamented that his critics “have not said a word of praise for the gratuitous work of education which the Government have undertaken.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote69",
      "id": "rfootnote69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[69]")])])]), _vm._v(" "), _c('p', [_vm._v("Ultimately, however, Milner’s policy of anglicizing Boer children was a double-edged sword for it stoked emergent Afrikaner nationalism. Indeed, a major aspect of Boer opposition to what came to be known as “Milnerism” was the compulsory use of English as the medium for educating Afrikaans-speaking children. This opposition quickly intensified into an anti-British nationalist movement that would have a profound impact on South Africa’s political development."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote70",
      "id": "rfootnote70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[70]")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("MAUD GRAHAM")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxiii"
    }
  }, [_vm._v("In April 1902 the (Toronto) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Globe")]), _vm._v(" proudly reported that “The forty young ladies who are going to South Africa from Canada to instruct the young Boers in the English language and train them up in the ways of civilization are handsome, athletic specimens of Canadian womanhood….If the young Boer farmers are at all susceptible to feminine influences one can easily foresee what will be the result of the arrival of such a bevy of handsome Canadian girls.”"), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote71",
      "id": "rfootnote71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[71]")]), _vm._v(" Maud Graham, a young woman from Ontario, was one of these “girls.” She was initially stationed at Norval’s Pont, located in the Cape Colony on the south side of the Orange River that separated it from the Orange River Colony. The camp was established in 1900 to relieve the overcrowded Bloemfontein camp. It housed a population of about 3,500 people, most of whom were extremely impoverished Boers, and was a relatively well-managed and resourced camp."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote72",
      "id": "rfootnote72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[72]")])]), _vm._v(" Once the camps were dismantled, Graham would remain in this region to teach in the towns of Fauresmith and Kroonstad. As the pages of her text make clear, the self-proclaimed “Canadian Girl in South Africa” was a forceful and direct young woman who did not shy away from sharing her opinions. A sense of her formative years in Canada is thus helpful in understanding the cultural influences that shaped the assessments and evaluations she offers in her memoir.")]), _vm._v(" "), _c('p', [_vm._v("Graham was born in 1876 in Owen Sound, Ontario, an industrial and port town on Georgian Bay, Lake Huron. She grew up an only child in a middle-class household of Irish Protestant descent. Her mother, Lydia Meir, came from a merchant family. In 1856 Lydia’s father, John Houghton Meir, bought several tracts of land in and around Owen Sound and by the 1870s had become a prosperous merchant. In 1879, for example, he purchased a four-bedroom family home and employed at least a general cook, a chore woman for washing and scrubbing, a maid, a “man-of-all-work,” and a “hired boy.” In the 1880s the original business was destroyed by fire and John Houghton Meir pursued a new endeavour with his son, George, opening the Montreal Tea Store. Maud’s father, Samuel Graham (1840–1907), owned S. Graham and Co., Shoes and Boots. In the 1860s Samuel’s father had moved from Brockville, in Eastern Ontario, to take up tracts of land near Chatsworth, a township located approximately fifteen kilometres south of Owen Sound. Samuel opened the store just after his marriage in 1868 to Lydia, and the family lived above the store. By 1882, the year Maud turned six, the family had prospered enough to purchase their own house."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote73",
      "id": "rfootnote73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[73]")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/Page_35.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxiv"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Norval’s Pont Camp")])])]), _c('a', {
    attrs: {
      "id": "page_xxxiv"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_xxxiv"
    }
  }, [_vm._v("Both the Meirs and the Grahams attended the local First Methodist church. The families were deeply involved in temperance activities in an attempt to reform Owen Sound’s reputation as a “hard drinking town”—a status reinforced by the existence of no less than six breweries by 1902."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote74",
      "id": "rfootnote74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[74]")]), _vm._v(" Maud’s mother, Lydia, and aunts Mary Ann and Martha, helped establish the Woman’s Christian Temperance Union (WCTU) branch in Owen Sound."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote75",
      "id": "rfootnote75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[75]")])]), _vm._v(" After her marriage to an American Methodist minister, Martha (now Mrs. J.A. Allen) became a leading WCTU "), _c('a', {
    attrs: {
      "id": "page_xxxv"
    }
  }, [_vm._v("worker in the United States."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote76",
      "id": "rfootnote76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[76]")]), _vm._v(" Their involvement with the WCTU linked them to a broader Anglo-American culture and provided a means for public involvement in their communities at a time when they lacked full citizenship rights."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote77",
      "id": "rfootnote77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[77]")])]), _vm._v(" Maud grew up with a daily visual reminder of this activism as her mother had hung a large photograph of Frances Willard, a leading American temperance advocate, in the home. Her father, Samuel, held leadership positions within the church and local community as superintendent of the Sunday school and president of the local Young Men’s Christian Association."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote78",
      "id": "rfootnote78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[78]")])]), _vm._v(" Graham’s family was thus deeply committed to temperance and the ideals of religious service.")]), _vm._v(" "), _c('p', [_vm._v("Maud Graham was also raised in a context that to some extent openly acknowledged the legacies and realities of slavery. Both the Graham and Meir families opposed slavery. Family lore indicates that Maud’s maternal grandfather, John Meir Senior, settled in Canada rather than the United States because of his strong abolitionist beliefs."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote79",
      "id": "rfootnote79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[79]")])]), _vm._v(" In the mid-nineteenth century, Owen Sound became one of the end points of the underground railroad, an escape route for slaves fleeing the United States, and had a small black community of about 200 that lived in poor conditions separate from the white population. Maud’s father, Samuel Graham, was actively involved in a local 1888 commemoration of the emancipation of British West Indian slaves."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote80",
      "id": "rfootnote80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[80]")])]), _vm._v(" He also served as assistant superintendent of the local British Methodist Episcopal Church sabbath school, which served the African-Canadian population."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote81",
      "id": "rfootnote81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[81]")])])]), _vm._v(" "), _c('p', [_vm._v("Given their family history and their strong involvement in temperance, a movement allied with abolitionism, Graham’s immediate family, then, likely held abolitionist beliefs. Of course, this certainly did not preclude them from abiding by and reinforcing common class- and race-based categories. If Maud was taught that both blacks and whites were God’s creations, her attitude was not one of equality. She encountered members of the black community primarily as servants, washer-women, gardeners, and cooks, and in her unpublished reminiscences she patronizingly notes with "), _c('a', {
    attrs: {
      "id": "page_xxxvi"
    }
  }, [_vm._v("fondness, “many of these old ex-slaves were really fine characters.”"), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote82",
      "id": "rfootnote82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[82]")]), _vm._v(" She generally uses the term “negro,” still a fairly common term when she wrote in 1931, but employs the term “nigger” when referring to an unrespectable black man who had deserted his wife."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote83",
      "id": "rfootnote83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[83]")])])]), _vm._v(" "), _c('p', [_vm._v("Graham was a highly educated woman. In 1892, at age sixteen, she graduated from Owen Sound Collegiate Institute."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote84",
      "id": "rfootnote84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[84]")])]), _vm._v(" In that year she began a four-year degree at the University of Toronto. This was a period when co-education was a hotly contested issue. Women only gained entry to the University of Toronto in 1884 and opponents of women’s higher education questioned the propriety of co-education for both its emasculating impact on men and masculinizing effects on women."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote85",
      "id": "rfootnote85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[85]")])]), _vm._v(" While female students belonged to separate student societies and were segregated in their own common room and reading room, they had also begun to form “a sizeable group in the lecture halls and corridors” and participated with men in some campus politics."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote86",
      "id": "rfootnote86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[86]")])]), _vm._v(" Graham engaged in a variety of extracurricular activities; for example, she was recording secretary of the university’s Women’s Literary Society and business manager of its magazine. She became president of the Women’s Athletic Club at the University of Toronto and organized the basketball team. She also participated in a number of tennis tournaments. She was an accompanist for the Ladies’ Glee Club as well as for Glee Club soloists who sang as part of the annual concert of the University Glee Club held at Massey Hall. And, as a delegate for University College, University of Toronto, Graham attended the inaugural meeting of the Council of Women in the 1890s."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote87",
      "id": "rfootnote87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[87]")])]), _vm._v(" In 1896 Graham received her BA in modern history. She received a fellowship in history at Bryn Mawr, a prestigious American women’s college, for the school year 1896–97."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote88",
      "id": "rfootnote88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[88]")])]), _vm._v(" She then returned to Canada to attend Ontario Normal College in Hamilton and qualified to teach at the high school or collegiate institute level in Ontario. Afterwards she took a position as a private governess in Quebec."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote89",
      "id": "rfootnote89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[89]")])]), _vm._v(" By the time she departed for South Africa, she had thus secured a record of scholarly, "), _c('a', {
    attrs: {
      "id": "page_xxxvii"
    }
  }, [_vm._v("administrative, and extracurricular achievement amidst a highly conservative but liberalizing co-educational culture. The seeds of the blunt assessments of the political and educational administrators in South Africa that she offers in her book may well have been sown during this period of her life.")])]), _c('a', {
    attrs: {
      "id": "page_xxxvii"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_xxxvii"
    }
  }, [_vm._v("In 1902, at age twenty-six, Graham set off to teach in South Africa, where she remained for two years. While there, Graham wrote a number of articles for the Montreal "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Witness")]), _vm._v(" that became the basis for her book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Canadian Girl in South Africa")]), _vm._v(", published in 1905. Graham was not the only teacher acting as a correspondent. Florence Randal, a journalist at the Ottawa "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal")]), _vm._v(" prior to accepting a post as a camp teacher, provided regular columns to that newspaper during her year abroad. In these activities Graham and Randal participated in a growing trend of Anglo-Canadian women’s public writings for newspapers, magazines, and in book format."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote90",
      "id": "rfootnote90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[90]")]), _vm._v(" Upon her return to Canada, Graham continued her support of imperial activities through participation in the local chapter of the Imperial Order Daughters of the Empire (IODE), a female imperialist organization established during the South African war aimed at strengthening Canada’s links to the British Empire."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote91",
      "id": "rfootnote91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[91]")])]), _vm._v(" Indeed, she became first “current Events Director” and then president of the Earl Grey Chapter of the IODE in Owen Sound."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote92",
      "id": "rfootnote92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[92]")])]), _vm._v(" She also taught at a high school in Harriston, Ontario and in 1907 became principal of the Girls’ High School in Quebec City. Graham does not seem to have continued her writing beyond the publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Canadian Girl")]), _vm._v(", producing only one article in subsequent years."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote93",
      "id": "rfootnote93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[93]")])])]), _vm._v(" "), _c('p', [_vm._v("In 1908 Graham married Frederick Gourlay Millar (1876–1972) of Wiarton, Ontario, a small village not far from Owen Sound. Like Graham, Millar attended the University of Toronto, graduating in 1898 with a degree in political science and English. The next year he graduated from the Ontario Normal School. He then undertook several years of post-graduate work at the University of Marburg, in Hesse, Germany, in history and languages. Millar spent four years teaching at Hamilton Collegiate Institute and became classical "), _c('a', {
    attrs: {
      "id": "page_xxxviii"
    }
  }, [_vm._v("master at the Boys’ High School, Quebec City. Several years after their marriage, Graham and Millar moved to Brantford, Ontario where Millar became an assistant in the commercial department at Brantford Collegiate Institute. From 1924 to 1944 he worked in Hamilton, becoming, in 1928, principal of Hamilton’s first High School of Commerce."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote94",
      "id": "rfootnote94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[94]")]), _vm._v(" Graham and Millar had three children (1910, 1914, 1916). In 1924 Graham became caregiver to both her aunt and mother until their deaths in 1930 and 1934, respectively. Maud Graham died in 1949.")]), _vm._v(" "), _c('p', [_vm._v("In many ways, Graham constituted the ideal of the New Woman—highly educated, newly independent, open to the latest in modern ideas, yet supported by middle-class professional business or farm families looking for respectable opportunities for their daughters. She was clearly strong-willed, ambitious, and ready to embrace the new opportunities opening up to women of her class at the turn of the century."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote95",
      "id": "rfootnote95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[95]")])]), _vm._v(" She also carried over into her own life her family’s involvement in social and moral reform. She remained a member of the National Council of Women, becoming president of the Ontario Provincial Council of Women from 1937 to 1942, and in 1946 prepared a brief on behalf of the Council to the Royal Commission on Education. She became president of the Brantford Home and School Council and was involved with the Hamilton Society for the Prevention of Cruelty to Animals. During the Second World War, she undertook regional work on the Wartime Prices and Trades Board and participated in Red Cross Society activities."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote96",
      "id": "rfootnote96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[96]")])])]), _vm._v(" "), _c('p', [_vm._v("It is difficult from biographical details to determine the nature of her personality. Conversations with Graham’s grandchildren, who would have been very young when she was alive, suggest she was formidable, if not a little terrifying. Her daughter remembered her as a loving mother and affectionate wife who was the disciplinarian of the family. She was a strong supporter of women’s education and held great admiration for prominent female experts, activists, and politicians. She was progressive for the time, believing it important that her daughter be educated in the “facts of life” and supporting "), _c('a', {
    attrs: {
      "id": "page_xxxix"
    }
  }, [_vm._v("family planning and contraception, perceiving large families to be injurious to women’s and children’s health. Yet, from her daughter’s perspective as a trained social worker, Graham seemed unaware of the deep racial prejudice in South Africa and, equally, during the Great Depression exhibited little empathy when it came to the causes of people’s personal poverty."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote97",
      "id": "rfootnote97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[97]")])]), _vm._v(" "), _c('p', [_vm._v("Graham’s book suggests that she was highly opinionated. Other archival fragments reinforce this view. In 1896–97, when Graham attended Bryn Mawr, she wrote an article comparing the female students there to those at the University of Toronto for the latter’s newspaper, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Varsity")]), _vm._v(", in which she stated that “the Toronto girl is vastly more attractive and well-bred.” She considered the conversation offered by the Bryn Mawr woman “to be as entertaining as that of a gawky ten-year-old school girl,” and suggested that they “suffer from those common defects of the American girl, a loud shrill voice, and a bad complexion, the latter being made worse by the amazing quantity of tea, coffee and ‘fudge,’ consumed at all hours of the days and night, for each girl has her own five o’clock tea-table in her study.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote98",
      "id": "rfootnote98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[98]")])])]), _vm._v(" "), _c('p', [_vm._v("An incident prior to Graham’s departure for South Africa confirms this feistiness. When Graham applied to become a camp teacher, she was working as a private governess for a family in Quebec City. After she learned that her application had been successful, she returned home to Owen Sound, likely to visit her parents and set her affairs in order before heading off. Because Graham had applied from Quebec, the government deemed she should only be reimbursed for expenses from that point of departure. Graham vigorously protested that decision and the government eventually capitulated."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote99",
      "id": "rfootnote99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[99]")])])]), _vm._v(" "), _c('p', [_vm._v("Graham’s formidable manner is equally recounted by a young Northrop Frye, who would later become a renowned literary scholar but at the time was known to the family simply as her son Graham’s friend from university. Visiting the family in the summer of 1933, Frye, in cutting tones, described a family ruled by Maud as matriarch:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_xl"
    }
  }, [_vm._v("It is curious to watch the rhythms of this family. Mrs. Millar snaps out everything she says like a drill sergeant and is disconcertingly impatient—her whole manner would be something like mine after teaching a week at an idiot school. She talks as fast as I do, but, her voice being higher by its regulation octave, gets away with it better, informing me in no uncertain terms that I have picked up a mumbling Jewish jargon at the university and have forgotten my mother tongue. Well, the whole family in reaction have adopted a pose of almost exaggerated deliberation and slowness both of speech and motion. The ensemble is something like a model T Ford—a spitting engine galvanizing a languid pile of tin into action. There’s nothing ill-natured about it, of course, and it’s quite amusing."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote100",
      "id": "rfootnote100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[100]")])]), _vm._v(" "), _c('p', [_vm._v("While Frye’s comments are those of a precocious young man, he offers a rare glimpse of Graham’s postwar domestic life. Graham’s feistiness, independence, and ambition seem to parallel that of Florence Randal. Like Graham, Randal married in 1908, but her daughter, renowned poet Dorothy Livesay, remembers her parents’ marriage as unhappy and recalls her mother’s inefficiency as a housekeeper and distance as a parent."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote101",
      "id": "rfootnote101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[101]")])]), _vm._v(" While generalizations on the basis of these two women should be tentative at best, their position at the turn of the century as educated career women in their mid-twenties may indicate the kinds of qualities possessed by the women teachers who volunteered for such an adventure. Yet, like some of the veterans of the war who returned before them, they may also have found it difficult to settle into the expectations of marriage and family life. Indeed, neither fully gave up their career—Randal continuing her writing and Graham returning to high school supply teaching at several points in the 1920s."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote102",
      "id": "rfootnote102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[102]")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A CANADIAN GIRL IN SOUTH AFRICA")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xli"
    }
  }, [_vm._v("Graham’s memoir details her trip to South Africa and the two years she spent living there. She departed Canada from Saint John, New Brunswick on April 19, 1902 and arrived June 1 to the announcement of peace. The book is informally divided into two sections. The first section, Chapters I to IX, describes the trip to South Africa, camp life, and her experiences teaching during the early reconstruction period. En route to South Africa the Canadian teachers stopped in London for several weeks where they were fêted and met a number of important British political and social figures, including the Balfours, Lord and Lady Roberts, Earl Grey, Lady Cecil, Joseph Chamberlain, the Baden-Powells, and Michael Sadler of the Education Department. Attention from such prominent people is another indication of the importance attached to this imperial endeavor. Once in South Africa, Graham describes her travels from Cape Town, through the interior sandy plateau of the Karoo, and on to Norval’s Pont where she settled in to teach. The second section, Chapters X to XIV, focuses on Graham’s explanations and opinions pertaining to five themes she thought important for understanding the social, political, and economic context of South Africa after the war: the reliance on African labour; the repatriation of displaced Boers and government compensation to them for the destruction of their homes and land; government relief works for landless Boers; the rising up of anti-British "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("predikants")]), _vm._v(" (church ministers) and the creation of church schools; and the challenges facing (white) farmers. In the process, she addresses the bonds of, and divisions within, the British Empire, the tense relationship between the British and Boers, and the central role of African labour in the economic life of southern Africa as well as, indirectly, the subservience of Africans in white social life. A brief concluding chapter documents her return to Canada.")])]), _c('a', {
    attrs: {
      "id": "page_xli"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_xli"
    }
  }, [_vm._v("At the time of its publication, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Canadian Girl")]), _vm._v(" received favourable reviews in newspapers and magazines."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote103",
      "id": "rfootnote103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[103]")]), _vm._v(" One contemporary reviewer "), _c('a', {
    attrs: {
      "id": "page_xlii"
    }
  }, [_vm._v("went so far as to suggest that “The mission of Miss Graham and her companions to the war-stricken colonies was an incident unique of its kind and well deserving of the place in Canadian history which the present little volume should secure for it.”"), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote104",
      "id": "rfootnote104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[104]")]), _vm._v(" In fact, the book did not become a “classic” of Canadian non-fiction writing. Despite receiving some favourable publicity, it seems to have created little stir."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote105",
      "id": "rfootnote105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[105]")])]), _vm._v(" Yet, at the time, the material in the book became one source that helped to shape Canadians’ outlook on the South African War and its aftermath. Many of the chapters, for example, were initially published as first-hand newspaper accounts of happenings in the new British colonies at the end of the war. After publication, extracts from the book appeared in magazines and newspapers."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote106",
      "id": "rfootnote106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[106]")])]), _vm._v(" And at least some reviewers thought the book a useful source for understanding the conditions in South Africa at the time. Graham’s book is especially important given the need for a greater understanding of daily life in the camps, as discussed above, and in the recently defeated Boer states more generally. Indeed, after publication, a review in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Manitoba Free Press")]), _vm._v(" emphasized the usefulness of the book as “the clearest impression it had yet seen of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the even tenor of every-day life")]), _vm._v(" in England’s newest colony.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote107",
      "id": "rfootnote107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[107]")])])]), _vm._v(" "), _c('p', [_vm._v("Graham’s memoir is useful for additional reasons: it provides an entry point into discussions about imperialism, emergent English-Canadian nationalism, New Women, schooling, issues of racism, and whiteness (the construction and maintenance of a white racial identity). First, it conveys the dominant Anglo views of the righteousness of the imperial mission and, in contrast to the critique developed by Hobhouse and others, of the camps’ utility. Like many English Canadians of British descent at the time, Graham adhered to a belief in the civilizing nature of the empire, and refers to Britain as the “Home Country” (Chapter I). By the 1890s many English-Canadians supported British imperialism, seeing it as “a potent political, economic, social and spiritual force.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote108",
      "id": "rfootnote108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[108]")])]), _vm._v(" By the time she arrived at Norval’s Pont, many of the more severe conditions documented by Hobhouse and others had been ameliorated. It is perhaps not surprising, then, that Graham’s view of the camps is much more benign. Indeed, her personal photograph album reveals an emphasis on the positive aspects of camp life. In an album that otherwise contains only brief captions, she wrote under one photograph of a mass of children in front of a building, “At 11 A.M. every one of the 1,300 school children was served with a mugful of rich hot soup, during the winter months.” Under another, featuring rows of vegetables, she noted, “Three times a week all refugees had a generous vegetable ration.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote109",
      "id": "rfootnote109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[109]")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/Page_44.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_c('a', {
    attrs: {
      "id": "page_xliii"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vegetable Rations, Refugee Camp, Norval’s Pont.")])])]), _c('a', {
    attrs: {
      "id": "page_xliii"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_xliii"
    }
  }, [_vm._v("Graham’s account thus fits within the suffrage tradition of Millicent Garrett Fawcett and other British imperialists, rather than that of the anti-war suffragists such as Hobhouse. In England, the National Union of Women’s Suffrage Societies became divided with significant numbers holding the latter position. Fawcett, on the other hand, strongly supported the war and attributed the high infant mortality rates in the camps not to living conditions but ")]), _c('a', {
    attrs: {
      "id": "page_xliv"
    }
  }, [_vm._v("rather to the ignorance of Boer women regarding basic hygiene."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote110",
      "id": "rfootnote110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[110]")]), _vm._v(" En route to South Africa, it is through meetings in London with Fawcett’s daughter and other female imperialists such as Agnes Baden-Powell, that the Canadian contingent received their first personal accounts of camp life, including the news that they “could hire Boer girls and Kafirs to do our housework” (Chapter II). Graham’s narrative thus has the effect of countering the impression of the dreadful conditions of camp life and reinforcing Fawcett’s assessment.")]), _vm._v(" "), _c('p', [_vm._v("Graham’s support for Britain was always balanced with a strong sense of herself as a “Canadian Girl.” While the British rationale for the war emphasized both the defense and extension of the empire, for Canadians the lead up to the war raised questions about Canada’s relationship to Britain and its place within the empire. Canadians’ backing of the war was never assured. While support for the war proved particularly strong within urban English Canada and among those of British descent, others, including agrarian and labour radicals, Christian socialists, anglophones of Irish and German descent, as well as a number of French-Canadian leaders, voiced significant dissent prior to the war."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote111",
      "id": "rfootnote111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[111]")])]), _vm._v(" Even among those supporting the war, an insipient nationalism was evident. Indeed, the first contingent fought as a Canadian unit under the Maple Leaf insignia and was led by a Canadian, proudly representing, according to Robert Page, “their nation’s first military effort on the world stage.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote112",
      "id": "rfootnote112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[112]")])])]), _vm._v(" "), _c('p', [_vm._v("Graham’s sense of Canadian identity can be seen throughout the text. She readily identifies with Canadians that she meets along the way (Chapters VI and VIII). Relating the story of one soldier who appears on her travels, she explains, “we felt our pride in our country swelling as he stood there, six feet of well-developed young Canada, with fair hair and blue eyes gleaming out of his brown skin” (Chapter VIII)."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote113",
      "id": "rfootnote113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[113]")])]), _vm._v(" Yet, in response to a Boer acquaintance’s attack on the English as “white devils,” she indignantly reminds the woman that she too is “British” (Chapter VIII). Throughout "), _c('a', {
    attrs: {
      "id": "page_xlv"
    }
  }, [_vm._v("the text, then, Graham understands herself to be both British and Canadian."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote114",
      "id": "rfootnote114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[114]")]), _vm._v(" This did not mean unquestioned support for either group, however. She and her colleagues are critical of some of the English teachers on board the ship from Southampton to South Africa because of their “immoral” behaviour of sitting on soldiers’ knees (Chapter III). Moreover, while she supports British colonial policy, she is critical of the ability of local officials in South Africa—criticism that is sharpest in the chapter on “Education and Church Schools.” Nor is she supportive of some of the questionable behaviour of Canadian soldiers (Chapter VIII). Yet it is clear that she supports the British endeavor in South Africa and that her time there reinforced her allegiance to the empire. She ends her account by referring to the memorials to fallen soldiers being erected across Canada in the wake of the war, including in her hometown of Owen Sound, as “silent but potent links binding us to our sister colony across the sea” (Chapter XV).")]), _vm._v(" "), _c('p', [_vm._v("Graham’s motives for volunteering, like those of many of the young men at the time from her town and country, included the desire to do her part for the empire."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote115",
      "id": "rfootnote115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[115]")])]), _vm._v(" Yet loyalty to the empire was but one reason for volunteering. The opportunity to teach in South Africa offered adventure too. Indeed, this is illustrated in the opening lines of the text, where Graham concurs with an old university acquaintance who, upon hearing of some of her experiences, exclaimed, “I wish I were a girl…You girls have the best of everything nowadays” (Chapter I). Graham’s daughter recorded that her mother applied for the position because she saw it as an opportunity “to see the world,” and in places the memoir pulses with a sense of excitement and eager anticipation of what lay ahead."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote116",
      "id": "rfootnote116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[116]")])]), _vm._v(" When describing the sea voyage from Southampton to Cape Town, for example, she recounts with pride and amusement how “with practice…we became quite skilful at dressing with our cabin boxes shooting in and out under our feet like trombones” (Chapter III). Her fellow teacher, Florence Randal wrote that she and the other Canadian teachers had “envied” the English and Scottish teachers who "), _c('a', {
    attrs: {
      "id": "page_xlvi"
    }
  }, [_vm._v("preceded them to South Africa by a few months and had wartime experiences to recount, such as being shot at while travelling by train."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote117",
      "id": "rfootnote117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[117]")]), _vm._v(" For some, the trip also offered a means to further one’s career. Randal recorded in her diary the possibilities that going to South Africa would provide in advancing her journalistic career, noting, “I would love the trip and the writing of it.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote118",
      "id": "rfootnote118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[118]")])]), _vm._v(" The Canadian teachers thus conform to the pattern historian Shula Marks has identified for nurses who volunteered from across the empire for the South African War, whose motives combined imperial loyalty, a wish for adventure, interest in travel, desire for career development, financial need, and a longing to emigrate."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote119",
      "id": "rfootnote119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[119]")])])]), _vm._v(" "), _c('p', [_vm._v("For many of the women engaged as teachers, the trip to South Africa would have been the opportunity of a lifetime. It offered a sea voyage; a stop in London where they rubbed shoulders with leading imperialists, famous performers, and members of the aristocracy, and, following established patterns, toured renowned sites such as the Royal Mews at Buckingham Palace, St. Paul’s Cathedral, and Covent Garden (where they saw King Edward and Queen Alexandra);"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote120",
      "id": "rfootnote120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[120]")])]), _vm._v(" rail travel; and travel across southern Africa by train and horse- and cattle-drawn cart. After arriving in Liverpool, Graham and her fellow teachers travelled by train to London in a reserved corridor coach, a recent innovation that facilitated passenger movement throughout the train car, of which she wrote, “That corridor coach was exciting. We visited from one compartment to another, and decided unanimously that such a car was ideal. Presently lunch was served in the dining-car, the way to which made us feel like a band of exploring Westerners” (Chapter II). By arriving at the end of the war, they witnessed the process of de-mobilization, received visits from soldiers as well as invitations to picnics, parties, and concerts, and found opportunities to engage in various athletic activities. For some, this socializing led to romantic evenings on the veldt and marriage proposals—indeed six of the twenty women that accompanied Graham married in South Africa (Chapter I)."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote121",
      "id": "rfootnote121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[121]")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/Page_48.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Graham socializing with other teachers and British soldiers at Norval’s Pont in 1902. Left: Maud Graham and Miss Arbuckle.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_xlvii"
    }
  }, [_vm._v("At times Graham’s rhetoric echoes that of the stereotypical “tourist.” She gushes at the prospect of meeting members of the British aristocracy in London (Chapter II). She makes snide comments about her “fellow-passengers” en route to Cape Town (Chapter III). More unsettling is her assessment of the poor in Santa Cruz on Teneriffe in the Canary Islands. Here she offers not a vivid and complex portrait but a caricature of the town’s beggars before triumphantly celebrating the teachers’ ability to secure “bargains” at the local shops (Chapter III). On other occasions, however, she willingly reassesses her initial assumptions—about effective modes of transportation (Chapter IV) or the cultural ")]), _c('a', {
    attrs: {
      "id": "page_xlviii"
    }
  }, [_vm._v("amenities available in Johannesburg (Chapter VI). And when she stops off in another Canary Islands locale, Las Palmas, during the voyage home she interrupts her description of the local inhabitants to briefly highlight what she identifies as the difficult plight of the indigenous women (Chapter XV). Somewhere in between these extremes is her celebratory but seemingly reflexive observation that any “Canadian who has not galloped over our great prairie lands will find it hard to understand the ‘monarch of all I survey’ sort of feeling one experiences on the veldt” (Chapter XIV)."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote122",
      "id": "rfootnote122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[122]")])]), _vm._v(" "), _c('p', [_vm._v("Graham treats her time in South Africa as an adventure, often enduring rough conditions with little complaint. Instead, she emphasizes the games and various forms of entertainment the teachers created on their voyage to the camps, and offers descriptions of facets of daily life while teaching that she finds interesting. She also makes repeated reference to the Cape’s natural beauty. Hence, Graham describes her first impression of Norval’s Pont as she and her fellow teachers were travelling by cart and horse: “As we rounded the huge, steep kopje [hill] separating the military from the refugee camp, we exclaimed with delight at the picture before us. To the left were enormous kopjes; at their base was the Orange River, winding along between green banks; to the right, and sloping up the opposite hillsides was the camp, with its long lines of tents glistening white in the morning sun” (Chapter V). She also makes light of the military tents in which they slept and of the storm that blew down their tent on their first night at Norval’s Pont, soaking their belongings. Later, in Fauresmith, she and a fellow teacher, Miss Arbuckle, kept house on their own rather than boarding with a local family. With scarce resources she downplays their efforts to secure fuel and leavened bread (Chapters V and VIII).")]), _vm._v(" "), _c('p', [_vm._v("As Cecilia Morgan explains in her study of English-Canadian transatlantic tourism, women “comprised a significant group among anglophone Canadian travel writers” between 1870 and 1930."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote123",
      "id": "rfootnote123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[123]")])]), _vm._v(" In many ways, Graham can be counted among this group. After all, her observations on a wide range of topics including "), _c('a', {
    attrs: {
      "id": "page_xlix"
    }
  }, [_vm._v("modern transportation, window-shopping opportunities, local populations, landscapes, and the historical significance of the sites she visits fit nicely within the pattern of turn-of-the-century English-Canadian female travellers’ accounts. Moreover, like other Canadian transatlantic travellers’ experiences of the period, Graham’s overseas excursion reinforced some of her pre-existing notions about her destinations while challenging others. But there are important differences as well. First, as Morgan notes, there has been very little work undertaken to explore the motivations and experiences of Canadian travellers venturing beyond Britain and Europe in the late nineteenth and early twentieth centuries."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote124",
      "id": "rfootnote124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[124]")]), _vm._v(" Graham’s recollections provide a glimpse of such escapades. Second, while Canada’s transatlantic tourists of the period showed a keen interest in political developments, such as suffrage campaigns, and embraced opportunities to expand their knowledge and cultural horizons, they did so primarily as leisure travellers. Graham, of course, travelled first to Britain and then to South Africa as a salaried employee with daily responsibilities in the classroom and beyond. Her observations on daily life and, in particular, contemporary political controversies were profoundly shaped by this subject position.")]), _vm._v(" "), _c('p', [_vm._v("Yet Graham’s experience was certainly not bereft of leisure. For example, physical culture and sport play a significant role in Graham’s narrative. This is perhaps not surprising given that she was selected to teach in South Africa “by reason of her educational ability, her fine physique, and training in athletics.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote125",
      "id": "rfootnote125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[125]")])]), _vm._v(" Graham clearly embraced participation in organized sport—one more of the new freedoms offered to young women in the late nineteenth century. As president of the Women’s Athletic Club at the University of Toronto, she would have been familiar with the facilities available to women at that institution. Her year at Bryn Mawr exposed her to more well-developed facilities and a formal physical culture program, including medical examinations and corrective exercises, increasingly common at the time at American women’s educational institutions. Indeed, "), _c('a', {
    attrs: {
      "id": "page_l"
    }
  }, [_vm._v("it led her to publicly admonish her alma mater for its lack of facilities and to advocate for a gymnasium."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote126",
      "id": "rfootnote126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[126]")]), _vm._v(" She also embraced the opportunity at Normal School to take courses in physical training and drill.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/Page_51.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Field hockey. From left to right: Mr. Purcell, Miss Webb, Capt. Smith, Mr. Carroll, Mr. Vandry, Miss Rose.")])]), _vm._v(" "), _c('p', [_vm._v("Graham’s narrative is, in fact, replete with references to physical activity, from participation in calisthenics on board the ship, to engaging in sports in camp, horseback riding, organizing the playground at the school in Fauresmith, and introducing children to games such as basketball, still a relatively recent invention at that time. Graham’s photograph album contains a number of pictures of mixed-gender field hockey games as well as matches on the South African Constabulary tennis court during the period she lived in Fauresmith."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote127",
      "id": "rfootnote127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[127]")])]), _vm._v(" In Kroonstad, Graham and other teachers organized a community field hockey program as a means to overcome some of "), _c('a', {
    attrs: {
      "id": "page_li"
    }
  }, [_vm._v("the social and political divisions between the Dutch and English (Chapters III and XII)."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote128",
      "id": "rfootnote128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[128]")]), _vm._v(" The teachers, then, used athletics as a means of building community. Yet their enthusiasm for athletics also reflects the way in which many of these women embraced the broadening social roles for women at home.")]), _vm._v(" "), _c('p', [_vm._v("If travelling to South Africa offered adventure, so too did teaching in the camp and town schools. Camp schools, like the teachers’ living conditions more generally, were very basic. Graham initially had 130 students at the Primer II level. School began at 9 A.M. and ended at 1:30 P.M. with a recess from 10:30 A.M. to 11 A.M. The school day started with twenty minutes of religious instruction in Dutch followed by a routine comprised of a hymn, a check for cleanliness, passing out of slates, pencils, and books, copying of figures and letters from the blackboard, singing (to teach English and release energy), recess, a lesson in reading, basic math, spelling, memorization of a new verse, and a simple story (Chapter V). The British government provided each teacher with £3 of teaching supplies. Teachers were free to choose from the Board of Education’s extensive holdings but the books on offer, including "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("100 Gems of English Scenery, Pictorial Britain and Ireland, A Natural History Picture Book for Children")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("England’s History as Pictured by Famous Painters")]), _vm._v(" are indicative of the kind of lessons the British government was keen to support. “Pictures will be found specially useful by the teachers in the camps,” British officials explained, but warned that “in their selection great care should be taken to avoid unsuitable subjects.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote129",
      "id": "rfootnote129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[129]")])])]), _vm._v(" "), _c('p', [_vm._v("Graham and Miss Arbuckle left Norval’s Pont for the town of Fauresmith in September 1902 where they worked until July 1903 and where Graham’s class, consisting of four levels, from beginners to Primer II, reached eighty-five students. The school had been destroyed during the war so she had to make do with two portable blackboards and twenty broken slates, relying on scraps of chalk brought in by the children (Chapter VIII). In July 1903, deciding to stay after her contract expired, Graham moved to Kroonstad where she remained for another year. Her descriptions of teaching at the "), _c('a', {
    attrs: {
      "id": "page_lii"
    }
  }, [_vm._v("various schools include many observations about aspects of children’s daily lives; for example, during the lunch break in Norval’s Pont, “the favourite games at recess were marbles for the boys, and skipping with a long rope for the girls” and elsewhere she describes the kinds of games that children played on holidays (Chapters V and VII).")])]), _c('a', {
    attrs: {
      "id": "page_lii"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/Page_53.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fauresmith teachers. From left to right: Mrs. V.D. Post, C. Gertrude Arbuckle, Mr. Morris, Miss Meintjes, Miss Blair, Maud Graham.")])])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_lii"
    }
  }, [_vm._v("It is clear, particularly in the chapter on “Education and Church Schools,” that Graham supported the idea of having one public school system for all white children. After the war, the Dutch Reformed Church began opening schools in order to preserve the use of the Dutch language and to protect its cultural and religious influence. Graham perceived this initiative to be dangerously divisive. Despite her own criticism of the Education Department ")]), _c('a', {
    attrs: {
      "id": "page_liii"
    }
  }, [_vm._v("for failing to employ effective Dutch teachers because they were suspected of pro-Boer sympathies—which resulted in a shortage of teachers able to instruct in Dutch—she gives short shrift to complaints that the British government was attempting to eradicate Dutch in the schools. While Graham supports the three hours a week of lessons in high Dutch, her assumption that English is the language of the educated is clear.")])]), _c('a', {
    attrs: {
      "id": "page_liii"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_liii"
    }
  }, [_vm._v("Graham’s text illuminates the pervasive racism of the time—a racism that can be seen on two levels, in relation to Africans as well as to Boers. In her text, Africans remain largely invisible. At one point, Graham comments that “although the country is so large, the population is small and constantly moving about, and one is soon impressed with the ‘knowability’ of everyone, as Kipling says of India” (Chapter VIII). The “population” in her eyes is white. The invisibility of black Africans was due, in part, to the fact that most Africans interned during the war lived in separate camps, as noted above, making it easier for Graham, as well as those who opposed the camps, to ignore their plight. Thus, when they appear in details of camp life it is generally as cooks, laundresses, or maids. These African women became an important part of the teachers’ lives, not only contributing to the daily functioning of the household but also to the positive atmosphere. Yet the sense of racial and class difference is redolent throughout the narrative. For example, Graham consistently uses the derogatory term “Kafir,” an Arabic word for infidel that was used by Boer and Brit alike."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote130",
      "id": "rfootnote130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[130]")]), _vm._v(" She describes Maria, their cook in Fauresmith, as “our Kafir” a woman who was “neat and smiling” and soon found to be “very teachable” (Chapter VIII). Equally, she uses the term “coolie” to refer to non-white workers (Chapters III, V, and VI). Attempting to relate the sense of humour of her African cooks, Graham un-self-consciously compares them to “mischievous children” (Chapter VIII). She also has a habit of employing the names “South Africa” and “Africa” interchangeably as though the two were the same thing—a typical example of how little Westerners knew (and often continue to know) about "), _c('a', {
    attrs: {
      "id": "page_liv"
    }
  }, [_vm._v("the incredible complexity and diversity of the continent’s peoples, cultures, and environments.")])]), _c('a', {
    attrs: {
      "id": "page_liv"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_liv"
    }
  }, [_vm._v("The issue of race, and racism, also arises in regard to Boer–Brit relations. The British imperialists perceived themselves to be racially superior to the Boers. Sir Bartle Frere (1815–1884), British high commissioner for Southern Africa from 1877 to 1880, wrote to Queen Victoria that the Boers “were a ‘most interesting and very primitive people’ who could be made ‘as loyal subjects to Your Majesty as the French Canadians.’”"), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote131",
      "id": "rfootnote131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[131]")]), _vm._v(" Though ultimately wrong on both counts, Frere’s sense of racial superiority is clear. Canadian and other imperialists perceived the war as one between British progress and Boer backwardness. Reports on the rationale for sending Canadian women to South Africa reflected that perception. A newspaper article in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Globe")]), _vm._v(" in April 1902 noted that the teachers’ purpose was “to instruct the young Boers in the English language and train them up in the ways of civilization.” The article continued, “The Canadian soldier boys won the admiration and respect of brother Boer by their prowess upon the field of battle. It now becomes the duty of Canadian maidens to bring the blessings of education and refinement into the homes of the Dutch.”"), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote132",
      "id": "rfootnote132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[132]")])])]), _vm._v(" "), _c('p', [_vm._v("Graham’s reports also affirm this general picture of the Boers, as she describes them as “too ignorant” to understand the need to stay in quarantine if they had a contagious disease and unaware of modern rules of hygiene (Chapter V). She claims that “the poorer Dutch women hadn’t the faintest idea of cooking anything properly,” thus contributing to their children’s poor health and the need for the camp to provide hot soup. And she notes that “the dirty ones were also ignorant ones, unable to speak any English, their children being quite unschooled.” This poorer class of Boers, she argues, “benefited by the camps. They had free schools, free medical attendance, wholesome food, and were obliged to be decently clean” (Chapter V). To Graham, imperial rule would act as a civilizing and uplifting force."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote133",
      "id": "rfootnote133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[133]")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_lv"
    }
  }, [_vm._v("Graham’s racism is also refracted through the lens of class, positing the laziness of the peasant Boers who are unschooled against “the educated classes” of Dutch in the camps for whom she has sympathy and from whom she often received hospitality after leaving Norval’s Pont (Chapters V and VIII). In her chapter on the landless Dutch, she reaffirms this class and racial hierarchy, commenting that these "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bywoners")]), _vm._v(" (squatters) as they were known, “seemed but little higher than the Kafirs in the scale of civilization.” Following common eugenic beliefs of the time, Graham perceived their poverty and their suspiciously dark skin tones as visible evidence of mental inferiority. Noting the children, she explains that “All were dark-skinned, in some cases showing obvious traces of a dash of Kafir blood. Such children were dull and phlegmatic.” Near the end of her memoir she states, “undoubtedly the triumph of the Afrikaner cause would have been a long step backward in the history of South African civilization” (Chapter XII).")])]), _c('a', {
    attrs: {
      "id": "page_lv"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "page_lv"
    }
  }, [_vm._v("Though the British perceived the Boers to be racially inferior, they were nevertheless white and of European ancestry. South Africa was to be treated, like Canada, New Zealand, or Australia, as a white settler society with whites given the political rights of their compatriots elsewhere. The fact that the war had pitted whites against whites raised racial anxieties. Piers Brendon notes that despite Lord Kitchener’s requests during the South African War for military aid from Indian soldiers serving under British commanders, “the London government feared that if brown soldiers defeated whites in the ‘Dark Continent’ they might be emboldened to attempt another uprising in the subcontinent.”"), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote134",
      "id": "rfootnote134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[134]")]), _vm._v(" At the same time, in Britain the war raised concerns about the quality of Anglo manhood. The poor physical condition and high rejection rates of many recruits, Britain’s inability to quickly defeat the Boers, the ineptness of some of its commanding officers, and the perceived moral lapse accompanying the creation of the camps, all fuelled broader fears about the degeneracy of the British race."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote135",
      "id": "rfootnote135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[135]")])]), _vm._v(" For Canadians, on the other hand, military success "), _c('a', {
    attrs: {
      "id": "page_lvi"
    }
  }, [_vm._v("“encouraged their citizen soldiers and their admirers back home to view themselves as a new, healthier, hardier breed, born of their Nordic environment.”"), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote136",
      "id": "rfootnote136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[136]")])]), _vm._v(" "), _c('p', [_vm._v("Although Graham exhibited the attitudes common among women of her ethnic and class background, she was, at times, notably curious about the places and people she encountered and open to having her assumptions about Boers and South Africa in general challenged and overturned."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote137",
      "id": "rfootnote137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[137]")])]), _vm._v(" En route to Norval’s Pont she and other teachers stopped at De Aar Junction to have lunch and, with time to spare before moving on, they visited a small Boer school located at the railway. She writes, it “was very up-to-date, and somewhat jarred our preconceived ideas of South African schools” (Chapter IV). Elsewhere she explains that she learned “to judge nothing by Canadian standards” (Chapter V). She describes how, after a fun trip to Johannesburg, she and her fellow teachers “felt vastly ashamed of our preconceived ideas of Johannesburg, which we had imagined to be a rough mining town with few of the comforts and none of the luxuries of civilization” (Chapter VI). Moreover, soon after moving to Fauresmith, she and Miss Arbuckle caused “a perfect sensation” by organizing a tea for the upper-class members of the community: a formal tea was an “unheard-of function” and she acknowledges “we should have found out the customs of the place” before organizing the event (Chapter VIII). Notably, she does not extend this humble approach to her assumptions about Africans. She does condemn Boer racism towards Africans, stating that “the Dutch…have reason to fear the Kafirs, for in the old days they oppressed them. Many a Dutchman has told me unblushingly that the Kafirs had no souls and were only fit to be slaves” (Chapter X). Yet she also remains steadfast in her belief that British policy towards Africans—which had long included violently subjugating African kingdoms in the region—is more enlightened than the crude racism of the Boers. She approves of the British policy of racial segregation as well as the hated, humiliating pass system, which forced African men to carry passes that stipulated "), _c('a', {
    attrs: {
      "id": "page_lvii"
    }
  }, [_vm._v("where they could work and live, and resulted in fines or imprisonment for those caught without them."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote138",
      "id": "rfootnote138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[138]")])]), _vm._v(" "), _c('p', [_vm._v("Graham, like many of her fellow teachers, was in her mid-twenties, and had embarked upon a career prior to her arrival in South Africa. She reveled in her independence. Her attitude and behaviour reflect the tensions inherent in experiencing life as a New Woman in the early twentieth century. Her teaching positions in South Africa afforded her exciting opportunities for independent reflection and personal growth. Indeed, in the opening lines of the book, she expresses an almost giddy amazement at the fact that she and her fellow female teachers have been permitted to embark upon such a bold undertaking. And yet her exasperation with official decision making belies the fact that, as a woman, her ability to effect institutional change was tightly proscribed. Structural elements thus combined and intersected with Graham’s own individual life experiences and personality to produce a memoir that boldly questions some widely shared contemporary assumptions about South Africa, British imperialism, and race relations, while reinforcing others.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("CONCLUSION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Graham sailed for home in July 1904, by which time, she writes, “scarcely a trace of the war remained” (Chapter XV). Much has been written over the past one hundred years about the war’s impact, but Graham’s text provides insight into areas needing further research. Her eyewitness account of living and working in Norval’s Pont can assist historians in the ongoing attempt to develop a more nuanced picture of life in the concentration camps. In addition, despite the broadening of military history to include aspects of social history, the history of Canadian women’s involvement in the camps is limited. Equally, Graham forms part of a transnational women’s history, of which we still know little from a Canadian perspective. While the teaching in the camps is often tacked on as an interesting or curious "), _c('a', {
    attrs: {
      "id": "page_lviii"
    }
  }, [_vm._v("side note to the war itself, the camp schools in fact marked the beginning of the reconstruction of South African educational policy, a proposed keystone for the maintenance of British control in South Africa—an objective in which Canadian women played a significant role. Moreover, the memoir can serve as a useful tool for understanding the history of British colonial education policy in Africa and elsewhere in the empire—a body of research that to date has focused mainly on the political overtones and social effects of colonial education on non-white subjects."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote139",
      "id": "rfootnote139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[139]")]), _vm._v(" Comparing and contrasting British colonial education policy for Boer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kampkinders")]), _vm._v(" and Africans will provide a better understanding of the importance of whiteness in the formulation of colonial policy more generally.")]), _vm._v(" "), _c('p', [_vm._v("Graham’s reminiscences of her two years in South Africa provide historians with a valuable, first-person account of the period during which the infamous concentration camps were closed, the reconstruction process began, and tensions between British and Boer communities were reshaped in light of the war’s end. Her observations, refracted through lenses shaped by dominant settler colonial discourses of race, gender, and class ideals, provide a valuable resource for historians of the South African War concentration camps as well as women’s historians who are keen to understand the tensions inherent in the changing place of women in Canada and elsewhere in the British Empire at the turn of the twentieth century. They also provide revealing insights into the dominant imperial gaze of the time. Graham’s racial identity, class position, and gender ideals all shaped her (sometimes highly problematic) evaluation of what she saw and chose to highlight. She was a middle-class Canadian woman staunchly supportive of British imperialism but frustrated by, and critical of, many of the male imperial authorities she encountered. At times, Graham’s book offers conventional views about the nature and role of the British Empire as well as British opinion on the South African War. It is thus useful as a means of illustrating popular views held at the "), _c('a', {
    attrs: {
      "id": "page_lix"
    }
  }, [_vm._v("time by the British. But as a New Woman she was never shy about expressing her opinions, offering pointed suggestions pertaining to postwar reconstruction, and apportioning blame. No longer fully impeded by extremely restrictive traditional notions of femininity, Graham was able to take advantage of the new educational opportunities available to women at the turn of the century and participate in newly formed organizations aimed at advancing the cause of women. Her text provides an opportunity for scholars to gain insight into women’s place at the turn of the century, the relationship between gender and imperialism, and the potential difference gender makes when the victors, the vanquished, the colonizers, and colonized meet in the very particular and complicated “contact zone” that developed out of this British government initiative."), _c('span', {
    staticClass: "supfoot"
  })]), _c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote140",
      "id": "rfootnote140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[140]")])]), _vm._v(" "), _c('p', [_vm._v("In reprinting Graham’s account we have retained its original presentation as much as possible. We have kept the original spelling, grammar, and punctuation—including inconsistencies—throughout the text. For example, Graham employs a mixture of American and British spelling conventions. When necessary we have provided brief annotations to clarify the meaning of a misspelled word or the identity of a person whose name is misspelled. However, we have not adhered to the pagination of the original edition. The original publication contained thirty-nine images as well as the portraits of thirty-eight of the forty Canadian teachers. We have only been able to reproduce twenty-one of these."), _c('span', {
    staticClass: "supfoot"
  }, [_c('span', {
    attrs: {
      "href": "#/33_NOTES#footnote141",
      "id": "rfootnote141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[141]")])]), _vm._v(" They appear in the text in close proximity to their location in the original publication. Any information added to the captions appears in roman.")]), _vm._v(" "), _c('p', [_vm._v("The maps and images that appear in this Introduction were not part of the original publication. Unless otherwise noted, the images are from Graham’s personal photo album. This edition of Graham’s account also includes extensive annotations. In addition to defining terms with which readers may be unfamiliar, the annotations focus primarily on providing historical context for Graham’s observations. "), _c('a', {
    attrs: {
      "id": "page_lx"
    }
  }, [_vm._v("Finally, we have provided a detailed subject and thematic Index to assist scholars interested in a particular aspect of Graham’s experience. No index was included in the original publication.")])]), _c('a', {
    attrs: {
      "id": "page_lx"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d72a8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_Introduction.vue
// module id = 72
// module chunks = 0